import { createEnumOptions } from '../shared/enum-option.interface';

export interface IProblem {
  id: string;
  severity: ProblemSeverity;
  objectid?: string | null;
  tags?: IProblemTag[];
}

export interface IProblemTag {
  tag?: string;
  value?: string;
}

export enum ProblemValue {
  ok = '0',
  problem = '1',
}

export enum ProblemSeverity {
  notClassified = '0',
  information = '1',
  warning = '2',
  average = '3',
  high = '4',
  disaster = '5',
}

export interface ProblemSettings {
  severity: ProblemSeverity[];
  gponRegex: string;
  uplinkRegex: string;
  createTicketTimeout: number;
  closeTicketTimeout: number;
  powerOutageTicketDescription?: string;
  powerOutageProblemRegex?: string;
  createPowerOutageTicketTimeouts?: ICreatePowerOutageTicketTimeout[];
}

export interface ICreatePowerOutageTicketTimeout {
  oltModelRegex: string;
  tagRegex: string;
  timeout: number;
}

export const defaultProblemSettings: ProblemSettings = {
  severity: [ProblemSeverity.disaster, ProblemSeverity.high],
  gponRegex: 'GPON\\s*(\\d+\\/\\d+\\/\\d+)',
  uplinkRegex: 'ethernet\\s*(\\d+\\/\\d+\\/\\d+)',
  createTicketTimeout: 0,
  closeTicketTimeout: 0,
  powerOutageTicketDescription:
    'Na OLT je výpadok napájania už {{timeout}} minút. Pravdepodobne je potrebný výjazd.',
  powerOutageProblemRegex: '^Power outage$',
  createPowerOutageTicketTimeouts: [
    { oltModelRegex: '^MA 5800$', timeout: 275, tagRegex: '^imco$' },
    { oltModelRegex: '^MA5800-X2$', timeout: 310, tagRegex: '^imco$' },
    { oltModelRegex: '^MA5800-X7$', timeout: 0, tagRegex: '^imco$' },
    { oltModelRegex: '^MA 5800$', timeout: 813, tagRegex: '^delta$' },
    { oltModelRegex: '^MA5800-X2$', timeout: 289, tagRegex: '^delta$' },
    { oltModelRegex: '^MA5800-X7$', timeout: 7, tagRegex: '^delta$' },
  ],
} as ProblemSettings;

export const problemSeverityEnumOptions = createEnumOptions({
  [ProblemSeverity.notClassified]: { label: 'Not classified', color: 'none' },
  [ProblemSeverity.information]: { label: 'Information', color: 'primary' },
  [ProblemSeverity.warning]: { label: 'Warning', color: 'warn' },
  [ProblemSeverity.average]: { label: 'Average', color: 'warn' },
  [ProblemSeverity.high]: { label: 'High', color: 'danger' },
  [ProblemSeverity.disaster]: { label: 'Disaster', color: 'danger' },
  _default: { label: '-' },
});

export const problemValueEnumOptions = createEnumOptions({
  [ProblemValue.problem]: { label: 'Problem', color: 'danger' },
  [ProblemValue.ok]: { label: 'Resolved', color: 'success' },
  _default: { label: '-' },
});
